import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  signal,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { TranslocoPipe } from "@jsverse/transloco";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "loren-home-alarms-table-actions",
  imports: [
    MatFormFieldModule,
    MatIcon,
    MatSelectModule,
    TranslocoPipe,
    MatButton,
  ],
    templateUrl: "./loren-home-alarms-table-actions.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./loren-home-alarms-table-actions.component.scss"
})
export class LorenHomeAlarmsTableActionsComponent {
  @Input() totalNumOfAlarms: number;
  @Input() alarmsOnPage: number;
  @Input() tableElement;
  @Output() alarmsIncreased = new EventEmitter();
  @Output() alarmsDecreased = new EventEmitter();
  @Output() selectionChanged = new EventEmitter();

  readonly minNumOfAlarms = 20;

  numOfAlarms = signal<number>(this.minNumOfAlarms);
  scrollNumber = signal<number>(0);
  totalElementsShown = computed(() =>
    Math.min(
      (this.scrollNumber() + 1) * this.numOfAlarms(),
      this.totalNumOfAlarms
    )
  );

  handleSelectionChange(value) {
    this.numOfAlarms.set(value);
    this.scrollNumber.set(0);
    this.selectionChanged.emit(value);
  }

  changeAlarms(change: 1 | -1) {
    this.scrollNumber.update((s) => s + change);
    const event = {
      scroll: this.scrollNumber(),
      numOfAlarms: this.numOfAlarms(),
    };
    if(change > 0) {
        this.alarmsIncreased.emit(event)
    } else {
      this.alarmsDecreased.emit(event);
    }
  }
}
